import { render, staticRenderFns } from "./MostAppreciated.vue?vue&type=template&id=68034fea&scoped=true"
import script from "./MostAppreciated.vue?vue&type=script&lang=ts"
export * from "./MostAppreciated.vue?vue&type=script&lang=ts"
import style0 from "./MostAppreciated.vue?vue&type=style&index=0&id=68034fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68034fea",
  null
  
)

export default component.exports